var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 104,
  height: 104,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3,
  filter: "url(#play_video_svg__a)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 52,
  cy: 46.851,
  rx: 30,
  ry: 29.851,
  fill: "#fff"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M44.5 36.804a1 1 0 0 1 1.53-.848l15.113 9.446a1 1 0 0 1 0 1.696L46.03 56.544a1 1 0 0 1-1.53-.848V36.804Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "play_video_svg__a",
  x: 0.039,
  y: 0.039,
  width: 103.922,
  height: 103.624,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.98
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5813_124442"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5813_124442",
  result: "shape"
})))));
export default SvgPlayVideo;